import { Finder } from '../../lib/Finder';
import { FinderEditModeHeaderCell } from './FinderEditModeHeaderCell';
import { FinderEditModeBodyCell } from './FinderEditModeBodyCell';

export const finderEditModeColumn = {
  dataIndex: Finder.EDITING,
  title: <FinderEditModeHeaderCell />,
  render: (value, row) => <FinderEditModeBodyCell item={row} />,
};
